
export const downIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="5.716" height="9.778" viewBox="0 0 5.716 9.778">
<path id="路径_12445" data-name="路径 12445" d="M3.984,4.961,2.254,3.392H9.778V2.324H2.262L3.992.755,3.159,0,.836,2.106l0,0L0,2.858,3.151,5.716Z" transform="translate(0 9.778) rotate(-90)" fill="#ef5858"/>
</svg>`
export const upIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="5.716" height="9.778" viewBox="0 0 5.716 9.778">
<path id="绿色" d="M3.984,4.961,2.254,3.392H9.778V2.324H2.262L3.992.755,3.159,0,.836,2.106l0,0L0,2.858,3.151,5.716Z" transform="translate(5.716) rotate(90)" fill="#29b569"/>
</svg>`
export const zeroIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" class="design-iconfont">
<path data-name="矩形 14887" transform="translate(3 5)" fill="#888" d="M0 0H6V2H0z"/>
</svg>
`